var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPasLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1778,
    height: 1778,
    viewBox: "0 0 1778 1778",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1660.66 1160.19L1166.81 889L1660.66 617.81C1701.62 595.317 1716.09 543.551 1692.72 503.084L1625.07 385.913C1601.71 345.446 1549.64 332.09 1509.68 356.315L1027.91 648.407L1039.97 85.1287C1040.97 38.411 1003.38 0 956.647 0H821.353C774.625 0 737.026 38.411 738.03 85.1287L750.094 648.407L268.315 356.319C228.358 332.094 176.293 345.449 152.929 385.916L85.2815 503.087C61.9175 543.554 76.3845 595.321 117.345 617.813L611.187 889L117.341 1160.19C76.3811 1182.68 61.914 1234.45 85.2815 1274.92L152.929 1392.09C176.293 1432.55 228.358 1445.91 268.315 1421.68L750.094 1129.59L738.026 1692.87C737.026 1739.59 774.625 1778 821.353 1778H956.651C1003.38 1778 1040.98 1739.59 1039.98 1692.87L1027.91 1129.59L1509.68 1421.68C1549.64 1445.91 1601.71 1432.55 1625.07 1392.08L1692.72 1274.91C1716.08 1234.45 1701.62 1182.68 1660.66 1160.19Z",
    fill: "#484DCA",
    fillOpacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasLogo);
export default __webpack_public_path__ + "static/media/pas_logo.be62f13409c1f914f4253980a74cdcd5.svg";
export { ForwardRef as ReactComponent };